export default __webpack_public_path__ + "static/media/4.1928b93d.png";